// Touro University's undergraduate majors in New York (#2743). Read on
// 2026-10-01 from each undergraduate college's own official majors list on
// touro.edu: Lander College of Arts & Sciences (Academics, "Majors"), Lander
// College for Men (Academics, "Majors"), Lander College for Women (Programs &
// Majors) and the New York School of Career and Applied Studies (Academics,
// "Majors and Professional Programs"). Touro's catalogs are hosted off
// touro.edu, so these college pages are the list used. The three Lander
// colleges do not name the degree for each major, so degree is null there;
// NYSCAS names it, and only its bachelor's majors are kept (Paralegal Studies,
// Radiography and Sonography are associate's or certificate programs and are
// left out). Left out everywhere: minors, certificates (LAS Healthcare
// Administration), and pre-professional tracks and sequences. Touro's other
// divisions (Hebrew Theological College, the School for Lifelong Education,
// Machon L'Parnasa and the campuses abroad) are not listed.
const majors = {
    "slug": "touro-university",
    "read": "2026-10-01",
    "intro": "Bachelor's majors at Touro's undergraduate colleges in New York, each from the college's own majors page. Minors, certificates, pre-professional tracks and associate's programs are left out.",
    "groups": [
        {
            "name": "Lander College of Arts & Sciences (Flatbush)",
            "source": {
                "label": "Lander College of Arts & Sciences, Academics",
                "url": "https://las.touro.edu/academics/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null,
                    "note": "CPA track, with an accelerated option."
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Business Administration",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Cybersecurity & Network Administration",
                    "degree": null
                },
                {
                    "name": "Digital Multimedia Design",
                    "degree": null,
                    "note": "Women's division only."
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Education",
                    "degree": null,
                    "note": "Women's division only."
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Management",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                },
                {
                    "name": "Mathematics/Actuarial Studies",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Speech Communications",
                    "degree": null,
                    "note": "Women's division only."
                }
            ]
        },
        {
            "name": "Lander College for Men",
            "source": {
                "label": "Lander College for Men, Academics",
                "url": "https://lcm.touro.edu/academics/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chinuch/Education",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Cybersecurity",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Management/Marketing",
                    "degree": null
                },
                {
                    "name": "Mathematics/Actuarial Studies",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                }
            ]
        },
        {
            "name": "Lander College for Women",
            "source": {
                "label": "Lander College for Women, Programs & Majors",
                "url": "https://lcw.touro.edu/academics/programs--majors/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null,
                    "note": "CPA."
                },
                {
                    "name": "Biology",
                    "degree": null,
                    "note": "Honors track available."
                },
                {
                    "name": "Business Management and Administration",
                    "degree": null,
                    "note": "With a concentration in accounting."
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Digital Multimedia Design",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Education/Special Education",
                    "degree": null,
                    "note": "Tracks: Early Childhood (Birth-Grade 2); Childhood (Grades 1-6)."
                },
                {
                    "name": "English Literature",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": null
                },
                {
                    "name": "Judaic Studies",
                    "degree": null,
                    "note": "In the Irving Montak Department of Judaic Studies."
                },
                {
                    "name": "Management",
                    "degree": null
                },
                {
                    "name": "Management/Marketing",
                    "degree": null
                },
                {
                    "name": "Mathematics/Actuarial Studies",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null,
                    "note": "Honors track available."
                },
                {
                    "name": "Psychology",
                    "degree": null,
                    "note": "Honors track available."
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Speech Communications",
                    "degree": null
                }
            ]
        },
        {
            "name": "New York School of Career and Applied Studies",
            "source": {
                "label": "NYSCAS, Academics",
                "url": "https://nyscas.touro.edu/academics/"
            },
            "majors": [
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Business Management and Administration",
                    "degree": "BS",
                    "note": "Concentrations in accounting, finance, management, marketing or information systems; also offered as an AS."
                },
                {
                    "name": "Cybersecurity and Network Administration",
                    "degree": "BS",
                    "note": "Also offered as an AS."
                },
                {
                    "name": "Education",
                    "degree": "BS"
                },
                {
                    "name": "Human Services",
                    "degree": "BS",
                    "note": "Also offered as an AS."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": null,
                    "note": "You design the major with your advisor."
                },
                {
                    "name": "Law and Social Science",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "Accelerated BSN",
                    "note": "Also offered as an AAS."
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
